import React from 'react';
import NoteModerationView from '../../components/moderator/NoteModerationView';

/**
 * NoteModerationPage - Individual note moderation interface
 * Accessible at /moderator/notes/:id
 * Provides detailed moderation interface for individual notes
 */
const NoteModerationPage: React.FC = () => {
  return (
    <div className="container-fluid py-4">
      <NoteModerationView />
    </div>
  );
};

export default NoteModerationPage; 